import { useNoteNames } from "../../Project/ProjectStore"
import { Music } from "./Music"

export class Modes{
    static Ionian = 0
    static Dorian = 1
    static Phrygian = 2
    static Lydian = 3
    static Mixolydian = 4
    static Aeolian = 5
    static Locrian = 6
    static Names = ['Ionian', 'Dorian', 'Phrygian', 'Lydian', 'Mixolydian', 'Aeolian', 'Locrian']
    static AltNames = ['Major', 'Dorian', 'Phrygian', 'Lydian', 'Mixolydian', 'Minor', 'Locrian']
    static SpectrumIndexes:number[] = [
        Modes.Lydian, 
        Modes.Ionian,
        Modes.Mixolydian,
        Modes.Dorian,
        Modes.Aeolian,
        Modes.Phrygian,
        Modes.Locrian
    ]
    static getModalScale = (keyTonic:number, rootPosition:number, repeatTonic?:boolean) => {
        const scale:number[] = Music.getKeyScale(keyTonic)
        const choppedNotes:number[] = scale.splice(0, rootPosition)
        const modalScale:number[] = scale.concat(choppedNotes)
        if(repeatTonic){
            modalScale.push(modalScale[0])
        }
        return modalScale
    }
    static getTonicOffset = (modeIndex:number) => {
        switch (modeIndex) {
            case 0:
                return 0
            case 1:
                return -2
            case 2:
                return -4
            case 3:
                return -5
            case 4:
                return -7
            case 5:
                return -9
            case 6:
                return -11
            default:
                return 0;
        }
    }
    static getKeyTonicNote = (modeTonic:number, modeIndex:number) => {
        const keyTonic:number = (modeTonic + Modes.getTonicOffset(modeIndex) + 12) % 12
        return keyTonic
    }
    static getParallelModeScale = (modeTonic:number, modeIndex:number, repeatTonic?:boolean) => {
        const keyTonic = Modes.getKeyTonicNote(modeTonic, modeIndex)
        const scale:number[] = Modes.getModalScale(keyTonic, modeIndex, repeatTonic)
        return scale
    }
}

export function useModalScale(keyTonic:number, rootPosition:number, repeatTonic?:boolean):number[]{
    return Modes.getModalScale(keyTonic, rootPosition, repeatTonic)
}
export function useModalScaleNoteNames(keyTonic:number, rootPosition:number, repeatTonic?:boolean):string[]{
    const scale:number[] = useModalScale(keyTonic, rootPosition, repeatTonic)
    const allNoteNames:string[] = useNoteNames()
    const scaleNoteNames:string[] = scale.map((noteTonic:number)=>{return allNoteNames[noteTonic]})
    return scaleNoteNames
}